import { z } from "zod";

// Schema
export const urlSchema = z.object({
  label: z.string(),
  href: z.string(), // 允许任何字符串格式，包括QQ号码、微信号等
});

// Type
export type URL = z.infer<typeof urlSchema>;

// Defaults
export const defaultUrl: URL = {
  label: "",
  href: "",
};
